module.exports = __webpack_public_path__ + "img/silver-medal.e449563f.png";